{
  "ACTIVITEITEN": {
    "ACTIEPUNTEN": {
      "BUTTON": {
        "SLUITEN": "Close"
      },
      "EXPORTNAAM": "Action points",
      "INFO_DETAIL": "Click on an row to open the details",
      "POPUP": {
        "TITEL": "Details"
      },
      "TITEL": "Corrective action points",
      "TOON": "Show",
      "VIEWS": {
        "ALLES": "All",
        "UITGEVOERD": "Executed",
        "UITVOEREN": "Execute"
      }
    },
    "KENBRI": {
      "DETAIL": {
        "BUTTON": {
          "RAPPORT_WEERGEVEN": "View Report"
        },
        "TABS": {
          "RESULTATEN": {
            "CORRECTIEF": {
              "TITEL": "Corrective"
            },
            "PREVENTIEF": {
              "AANTAL_WERKCODES": "#Work codes",
              "TITEL": "Preventive",
              "VRAAG": "Question",
              "VRAGENBLOK": "Question block"
            }
          }
        }
      },
      "GRID": {
        "DETAIL": {
          "OBJECTEN": {
            "TITEL": "Objects"
          },
          "RAPPORTEN": {
            "GRID": {
              "RAPPORT": "Report",
              "TITEL": "Available reports"
            },
            "MELDING": {
              "NIET_GELADEN": "The available reports cannot be loaded, please contact the administrator"
            },
            "TITEL": "Reports"
          }
        },
        "PDF_RAPPORT_WEERGEVEN": "View PDF report",
        "RAPPORT_AANMAKEN_EN_WEERGEVEN": "Generate and view report"
      },
      "RAPPORT": {
        "MELDING": {
          "AANGEMAAKT": "The report with {{objectsNumber}} is currently being retrieved, for many objects this may take up to several minutes...",
          "OBJECT": "object",
          "OBJECTEN": "objects",
          "OPGEHAALD_CLOUD": "The PDF report is being retrieved from the cloud..."
        },
        "TITEL": "Activity report - {{title}}"
      },
      "ZOEKEN_OP_KLACHT": "Search for complaint"
    },
    "KLANT": {
      "DETAIL": {
        "GRID": {
          "VRAAG": "Question",
          "VRAGENBLOK": "Question block"
        },
        "POPUP": {
          "BUTTON": {
            "ANNULEREN": "Cancel",
            "OPSLAAN": "Save comment"
          },
          "OPMERKING": "Comment"
        }
      }
    },
    "PERIODE_OVERZICHT": {
      "BUTTON": {
        "RAPPORT_AANMAKEN": "Create report"
      },
      "GRID": {
        "PDF_RAPPORT_WEERGEVEN": "View PDF report",
        "RAPPORT_AANMAKEN_WEERGEVEN": "Generate and view report"
      },
      "HEADER_TEKST": "Overview of activities from {{startDate}} to {{endDate}}",
      "TOTAAL": "Total"
    }
  },
  "ALGEMEEN": {
    "ANNULEREN": "Cancel",
    "EVEN_GEDULD": "Please be patient...",
    "FOUT": {
      "KAN_GEGEVENS_NIET_LADEN": "The data could not be loaded, please contact the administrator",
      "KAN_KLANT_STATISTIEKEN_NIET_LADEN": "The customer activity statistics cannot be loaded, please contact the administrator",
      "TITEL": "Error"
    },
    "GEEN_VERTALING": "Missing translation: {{tag}}",
    "GELUKT": "Succes",
    "JA": "Yes",
    "KIES_TAAL": "Kies je taal/Choose your language/Wählen Sie Ihre Sprache",
    "LETOP": "Warning",
    "MISLUKT": "Failed",
    "NEE": "No",
    "OPSLAAN": "Save",
    "RAPPORT_WORDT_OPGEHAALD": "The report is being retrieved...",
    "TAALKEUZE_VERPLICHT": "You have to make a choice",
    "TAAL_GEWIJZIGD": "The language has been changed successfully",
    "TAAL_NIET_GEWIJZIGD": "The language is not changed",
    "WAARSCHUWING": "Warning"
  },
  "Algemeen": {
    "LicentieActief": "License activated",
    "LicentieVerlopen": "License expired"
  },
  "BEHEER": {
    "GEBRUIKERS": {
      "GRID": {
        "AANGEMAAKT_OP": "Created at",
        "AANTAL_ROLLEN": "#Roles",
        "BESCHIKBARE_KLANTEN": "Available customers for {{userName}}",
        "BUTTON": {
          "KOPPEL": "Connect selected customers",
          "ONTKOPPEL": "Disconnect selected customers"
        },
        "EMAIL": "Email",
        "GEBLOKKEERD": "Blocked",
        "GEBLOKKEERD_TOT": "Blocked until",
        "GEBRUIKERSNAAM": "Username",
        "GEKOPPELDE_KLANTEN": "Customers linked to {{userName}}",
        "HERHAAL_WACHTWOORD": "Repeat password",
        "KLANT": "Customer",
        "LAATST_INGELOGD": "Last login time",
        "ROL": "Role",
        "UITSLUITEN": "Exclude",
        "WACHTWOORD": "Password",
        "WACHTWOORD_KOMT_NIET_OVEREEN": "The passwords doe"
      },
      "MFA": {
        "RESET": {
          "CONFIRM": {
            "TEKST": "Are you sure you want to reset MFA for user {{username}}?",
            "TITEL": "Confirm MFA Reset"
          },
          "FOUT": "Resetting MFA for {{username}} failed: {{error}}",
          "SUCCES": "MFA has been reset for user {{username}}"
        }
      },
      "TITEL": "Users"
    }
  },
  "CONTACTGEGEVENS": {
    "TITEL": "Contact details"
  },
  "DASHBOARD": {
    "KENBRI_ACTIEPUNTEN": {
      "TITEL": "Kenbri corrective action points",
      "UITGEVOERD": "Executed",
      "UITVOEREN": "Execute"
    },
    "KENBRI_ACTIVITEITEN": {
      "INGEPLAND": "Scheduled",
      "IN_UITVOERING": "In progress",
      "TE_PLANNEN": "To plan",
      "TITEL": "Kenbri activities",
      "UITGEVOERD": "Executed"
    },
    "KENBRI_KPI": {
      "CHART_TITEL": "Kenbri activities",
      "TITEL": "Kenbri KPI's"
    },
    "NIEUWS": {
      "TITEL": "NEWS"
    },
    "OBJECTEN": {
      "KENBRI_ADVIES": "Kenbri advises to take action in case of deviations within the following time frame",
      "TITEL": "Objects",
      "TOTAAL_AANTAL": "Number of objects"
    },
    "STATUS_OBJECTEN": {
      "TITEL": "Status overview objects"
    }
  },
  "DOCUMENTEN": {
    "ALGEMEEN": {
      "BESTAND_GEUPLOAD": "File {{fileName}} is uploaded",
      "BESTAND_NIET_GEUPLOAD": "File {{fileName}} is not uploaded",
      "DETAIL": {
        "TITEL": "Edit document"
      },
      "FOTO_FOUT_TEKST": "The photo cannot be displayed, please contact the administrator",
      "FOUT_TEKST": "'The documents cannot be loaded, please contact the administrator",
      "FOUT_TITEL": "Error",
      "GELUKT": "Success!",
      "GRID": {
        "AANGEMAAKTOP": "Created at",
        "DOCUMENTSOORT": "Document type",
        "GROOTTE": "Size",
        "LAATSTGEWIJZIGDOP": "Last updated at",
        "NAAM": "Name",
        "OPMERKINGEN": "Comments"
      }
    },
    "OBJECT": {
      "GRID": {
        "AANGEMAAKTOP": "Created at",
        "DOCUMENTSOORT": "Document type",
        "GROOTTE": "Size",
        "LAATSTGEWIJZIGDOP": "Last changed at",
        "NAAM": "Document name",
        "OBJECT": "Object",
        "OPMERKINGEN": "Comments",
        "RAPPORT_FOTO": "Report photo"
      },
      "TITEL": "Documents"
    },
    "RAPPORTAGE": {
      "GRID": {
        "AANGEMAAKTOP": "Created at",
        "DOCUMENTSOORT": "Document type",
        "GROOTTE": "Size",
        "LAATSTGEWIJZIGDOP": "Last changed at",
        "NAAM": "Name",
        "OPMERKINGEN": "Comments"
      },
      "TITEL": "Reporting"
    },
    "TITEL": "Documents",
    "UPLOAD_DOCUMENT": "Upload document"
  },
  "FEEDBACK": {
    "FORMULIER": {
      "BERICHT": {
        "LABEL": "Description",
        "PLACEHOLDER": "What's the bug? What did you expect?"
      },
      "BUTTON": {
        "ANNULEREN": "Cancel",
        "BEVESTIGEN": "Confirm",
        "SCHERMAFBEELDING": {
          "TOEVOEGEN": "Remove screenshot",
          "VERWIJDEREN": "Add a screenshot"
        },
        "VERSTUREN": "Send Bug Report"
      },
      "EMAIL": {
        "LABEL": "Your emailadres",
        "PLACEHOLDER": "Email"
      },
      "NAAM": {
        "LABEL": "Name",
        "PLACEHOLDER": "Your name"
      },
      "SUCCESBERICHT": "Thank you for your report!",
      "TITEL": "Report a Bug",
      "VELD_VERPLICHT": "(required)"
    },
    "LABEL": "Report a Bug"
  },
  "GEBRUIKERMENU": {
    "LOGO_UPLOADEN": "Upload logo",
    "MFA_RESET": "Reset MFA",
    "MFA_RESET_BUTTON_CANCEL": "Cancel",
    "MFA_RESET_BUTTON_CONFIRM": "Confirm",
    "MFA_RESET_GELUKT": "Multi-Factor Authentication has been reset. You'll be prompted to set up MFA again the next time you log in.",
    "MFA_RESET_GELUKT_TITLE": "Reset MFA",
    "MFA_RESET_MISLUKT": "An error occurred while resetting your Multi-Factor Authentication. Please contact Kenbri.",
    "MFA_RESET_QUESTION": "Are you sure you want to reset your Multi-Factor Authentication?",
    "MFA_RESET_REQUIRE_PASSWORD": "Enter your password to confirm:",
    "TAAL_WIJZIGEN": "Change language",
    "UITLOGGEN": "Logout",
    "WACHTWOORD_WIJZIGEN": "Change password"
  },
  "HELP": {
    "FAQ": {
      "FORMULIER": {
        "BERICHT_OF_VRAAG": "Your message or question",
        "KNOP_VERSTUREN": "Send",
        "ONDERWERP": "Subject",
        "ONDERWERP_VERPLICHT": "Please enter the subject",
        "TEKST_VERPLICHT": "Fields marked with a<span class=\"dx-field-item-required-mark\"> *</span> are required.",
        "TITEL": "Contact",
        "VRAAG_NIET_VERSTUURD": "Your question was not successfully received due to a technical error",
        "VRAAG_VERPLICHT": "Please enter a message or question",
        "VRAAG_VERSTUURD": "Your question has been successfully received"
      }
    }
  },
  "INFO": {
    "GEPLANDE_WIJZIGINGEN": {
      "TITEL": "Planned changes for",
      "VERSIE": "Version"
    },
    "LICENTIE": {
      "DAG": "day",
      "DAGEN": "days",
      "ISACTIEF": "License is active",
      "NOG": "yet",
      "RESTEREND": "remaining",
      "TITEL": "Your license",
      "TOT": "until"
    },
    "NIEUWS": {
      "GEEN_NIEUWS": "There is no news at this moment.",
      "NIEUWS_BLIJFT_ZIEN_TOT": "News item is visible up to and including:"
    },
    "VERSIE_OVERZICHT": {
      "VERSIE": "Version"
    }
  },
  "KLANTLOGO": {
    "POPUP": {
      "BUTTON_UPLOAD": "Upload new logo",
      "GEEN_LOGO": "No logo has been uploaded yet, click the button below to upload a logo",
      "TITEL": "Change customer logo"
    }
  },
  "LICENTIE": {
    "BIJNA_VERLOPEN": {
      "TEKST": "<p>The license of {{customerName}} expires in {{numberOfDays}} {{dayLabel}}. After that, you will no longer be able to open the portal. </p><p>Contact Kenbri on +31(0)187493588 to renew your license.</p>",
      "TITEL": "Please note: the license is about to expire"
    },
    "VERLOPEN": {
      "TEKST": "The license of {{customerName}} has expired, please contact Kenbri at +31(0)187493588 to renew the license.",
      "TITEL": "The license has expired"
    }
  },
  "LOGIN": {
    "BUTTON": {
      "INLOGGEN": "Login"
    },
    "FOUTMELDING": "Error",
    "GEBRUIKERSNAAM": "Username",
    "LOGIN_HINT": "Log in with your username and password",
    "MELDING": {
      "GEBRUIKERSNAAM_VERPLICHT": "Username is required",
      "ONDERHOUD": "Due to maintenance, TotalCare is temporarily unavailable.",
      "SESSIE_VERLOPEN": {
        "TEKST": "The session has expired, you must log in again.",
        "TITEL": "Session is expired"
      },
      "TECHNISCHE_FOUT": "A technical problem has occurred, please try again or contact the administrator",
      "WACHTWOORD_VERPLICHT": "Password is required"
    },
    "MFA": {
      "CODE_INVOEREN": "Please enter the code from your authenticator app:",
      "FOUTMELDING": "Unable to login",
      "GEEN_TOEGANG": "I can't access my authenticator app",
      "HERSTELCODE_INVOEREN": "Enter one of your recovery codes to log in",
      "TERUG_NAAR_CODE": "Back to code input",
      "VALIDEREN": "Verify…"
    },
    "TITEL": "Login TotalCare portal {{environmentName}}",
    "WACHTWOORD": "Password",
    "WACHTWOORD_VERGETEN": "Forgot your password?"
  },
  "MENU": {
    "ACTIVITEITEN": {
      "ACTIEPUNTEN": "Actionpoints",
      "KENBRI_ACTIVITEITEN": "Kenbri activities",
      "NOTULEN": "Meeting minutes",
      "PERIODE_OVERZICHT": "Period overview",
      "TITEL": "Activities"
    },
    "BEHEER": {
      "GEBRUIKERS": "Users",
      "PRESENTER": {
        "TITEL": "Presenter"
      },
      "TITEL": "Management"
    },
    "CONFIGURATIE": {
      "AUTORISATIE": "Autorisation",
      "ROLLEN": "Roles",
      "TITEL": "Configuration"
    },
    "CONTACTGEGEVENS": {
      "TITEL": "Contact details"
    },
    "DASHBOARD": "Dashboard",
    "DOCUMENTEN": {
      "ALGEMEEN": "General",
      "OBJECTEN": "Objects",
      "RAPPORTAGE": "Reporting",
      "TITEL": "Documents"
    },
    "HELP": {
      "FAQ": "FAQ",
      "HANDLEIDINGEN": "Manuals",
      "TITEL": "Help"
    },
    "INFO": {
      "GEPLANDE_WIJZIGINGEN": "Upcoming changes",
      "NIEUWS": "News",
      "TITEL": "Info",
      "UW_LICENTIE": "Your license",
      "VERSIE_OVERZICHT": "Version overview"
    },
    "OBJECTEN": {
      "AANGEVRAAGD": "Requested",
      "EXTERNE_KOPPELINGEN": "External links",
      "OVERZICHT": "Overview",
      "TITEL": "Objects",
      "VERVALLEN": "Expired"
    },
    "PLANNING": {
      "TITEL": "Planning"
    },
    "SEVESO": {
      "ACTIEPUNTEN": "Actionpoints",
      "DASHBOARD": "Dashboard",
      "DOCUMENTEN": "Documents",
      "DOSSIERS": "Dossiers",
      "MODEL": "Model",
      "TITEL": "SEVESO",
      "TRENDS": {
        "LEVENSDUUR": "Lifespan",
        "NUMERIEKE_DATA": "Numeric data",
        "TITEL": "Trend analyses",
        "WERKCODES": "Work codes"
      }
    },
    "WERKCODE_ANALYSE": {
      "TITEL": "Work code analysis"
    }
  },
  "MFA": {
    "SETUP": {
      "BUTTON": {
        "VOLGENDE": "Next step"
      },
      "DANKJEWEL": "Thank you, MFA is successfully enabled!",
      "FOUTMELDING": "Unable to setup multifactor authentication, please return to the login page and try again.",
      "HERSTELCODES_UITLEG": "Copy the recovery codes below and keep them in a safe place, you can use them to recover your account if you no longer have access to the authenticator app",
      "INSTRUCTIES": "Enabling multifactor authentication is required to proceed. Scan the QR code with your authenticator app (Google Authenticator, Microsoft Authenticator, etc.)",
      "INSTRUCTIE_HANDMATIG": "Or enter this code manually",
      "ONGELDIGE_CODE": "Invalid code. Please try again.",
      "TERUGNAARINLOGGEN": "Back to login page",
      "TITLE": "Setup multifactor authentication",
      "VALIDEREN": "Verify...",
      "VUL_CODE_IN": "Enter the 6-digit code from your authenticator app"
    }
  },
  "NOTULEN": {
    "GRID": {
      "DETAIL": {
        "ACTIEPUNTEN": {
          "TITEL": "Action points"
        }
      }
    },
    "TITEL": "Meeting minutes"
  },
  "OBJECTEN": {
    "AANGEVRAAGD": {
      "FABRIKANT": "Manufacturer",
      "INSTALLATIE_DATUM": "Installation date",
      "LOCATIE_OBJECT": "Object location",
      "NAAM": "Name",
      "POPUP": {
        "BUTTON_CANCEL": "Cancel",
        "BUTTON_SAVE": "Save object",
        "TITEL": "Create new object"
      },
      "PREVENTIEF_NUMMER": "Preventive number",
      "PRODUCTGROEP": "Productgroup",
      "SERVICE": "Service performed by Kenbri",
      "TITEL": "Requested objects",
      "TYPE": "Type",
      "UW_LOCATIE": "Your location"
    },
    "DETAIL": {
      "AANMAKEN_RAPPORT": "The report with {{objectsNumber}} is currently being retrieved, for many objects this may take up to several minutes...",
      "ACTIVITEIT_RAPPORT_TITEL": "Activity Report - {{title}}",
      "DOCUMENTEN": {
        "GRID": {
          "RAPPORT_FOTO": "Report photo"
        },
        "TITEL": "Linked documents"
      },
      "GEKOPPELDE_ACTIVITEITEN": {
        "GRID": {
          "ACTIVITEIT_WEERGEVEN": "Show activity",
          "OMSCHRIJVING": "Description",
          "PDF_RAPPORT_GENEREREN_WEERGEVEN": "Generate and open PDF report ",
          "PDF_RAPPORT_WEERGEVEN": "Show PDF report"
        },
        "TITEL": "LINKED KENBRI ACTIVITIES"
      },
      "KLANTAFSPRAKEN": {
        "BUTTON_OPSLAAN": "Save this stupid things"
      },
      "LADEN_CLOUD_RAPPORT": "The PDF report is being retrieved from the cloud...",
      "OBJECT_RAPPORT_TITEL": "Object report - {{title}}",
      "WERKCODES": {
        "GRID": {
          "JAAR": "Year",
          "OPMERKING": "Comments",
          "STATUS": "State",
          "WERKCODE": "Workcode"
        },
        "TITEL": "Workcodes"
      }
    },
    "EXTERNE_LINKS": {
      "GRID": {
        "APPLICATIE": "Application",
        "DETAIL": {
          "BUTTON_KOPPELEN": "Link selected objects",
          "BUTTON_ONTKOPPELEN": "Disconnect selected objects",
          "GEKOPPELDE_OBJECTEN": "Linked objects",
          "OBJECT": "Object",
          "TE_KOPPELEN_OBJECTEN": "Available objects"
        },
        "LINK": "Link"
      },
      "TITEL": "External links"
    },
    "OBJECT_AANVRAGEN": "Request object",
    "OVERZICHT": {
      "GRID": {
        "AANTAL_SUBOBJECTEN": "#Subobjects",
        "ACTIEPUNTEN_WEERGEVEN": "Show actionpoints",
        "ACTIVITEIT_WEERGEVEN": "Show activity",
        "BEDRIJFSUREN": "Operating hours",
        "CHASSISBOUWER": "Chassis builder",
        "CONCEPT": "Concept",
        "DETAILS_WEERGEVEN": "Show details ",
        "EXTERNE_LINKS": "External links",
        "EXTERNE_LINKS_WEERGEVEN": "Show external links",
        "FABRIKANT": "Manufacturer",
        "FILTER_WISSEN": "Clear filter",
        "HATZGENERATOR": "Hatzgenerator",
        "INSPECTIE_LOCATIE": "Inspection location",
        "JAAR": "Year",
        "KILOMETERSTAND": "Mileage",
        "KLANT_AFSPRAKEN": "Customer appointments",
        "KLANT_LOCATIE_WZH": "Customer location activities",
        "LAATSTE_ACTIVITEIT": "Last activity",
        "NAAM": "Name",
        "OPENSTAANDE_ACTIEPUNTEN": "Outstanding action items",
        "OPEN_DETAIL": "Open detail data in a new tab:",
        "OPVOLGING": "Succession",
        "PREVENTIEF_NUMMER": "Preventive number",
        "PRODUCTGROEP": "Productgroup",
        "RAPPORT_WEERGEVEN": "Show report",
        "ROEPNUMMER": "Call number",
        "STATUS": "State",
        "TYPE": "Type",
        "UITVOERING": "Version",
        "VOLGENDE_ACTIVITEIT": "Next activity"
      },
      "TITEL": "Objects overview"
    },
    "VERVALLEN": {
      "TITEL": "Expired objects"
    }
  },
  "PLANNING": {
    "DETAIL": {
      "STATUS": "Status"
    },
    "DETAIL_MEDEWERKER": "Employee",
    "DETAIL_OBJECT": "Object",
    "DETAIL_OPEN_ACTIVITEIT": "Open activity",
    "DETAIL_OPEN_RAPPORT": "Open report",
    "DETAIL_ORDERNUMMER": "Ordernumber",
    "DETAIL_REFERENTIE": "Reference",
    "LEGENDA": {
      "CONCEPT": "Kenbri activity",
      "EIGEN": "Own activity",
      "KENBRI": "Kenbri concept activity"
    },
    "TITEL": "Planning"
  },
  "RAPPORT": {
    "FOUT": {
      "TEKST": "An error has occurred, the report cannot be loaded. Please contact Kenbri via +31(0)187493588.",
      "TITEL": "Error"
    },
    "VIEWER": {
      "MELDING": {
        "FOUT": {
          "KAN_RAPPORT_NIET_OPENEN": "An error has occurred, the report cannot be loaded. Please contact Kenbri via +31(0)187493588.",
          "ONGELDIGE_LINK": "The link used is invalid, for questions please contact Kenbri on +31(0)187493588.",
          "TITEL": "Error message"
        },
        "LADEN": "Please wait, the pdf report is being retrieved from the cloud...",
        "OPENEN": "Opening the document, for many objects this may take up to several minutes...."
      },
      "TITEL": "Report for activity: {{klantReferentie}}"
    }
  },
  "SEVESO": {
    "Configuration": {
      "Grid": {
        "BeginDatum": "Start date",
        "Omschrijving": "Omschrijving",
        "Vervallen": "Vervallen",
        "Volgorde": "Volgorde"
      },
      "Title": "Beheren SEVESO dossiers"
    }
  },
  "TRENDS": {
    "GEGEVENS_TONEN_VOOR": "Show data for",
    "LEVENSDUUR": {
      "AANTAL": "Number of objects",
      "ALLE_PRODUCTGROEPEN": "All product groups",
      "TITEL": "Objects lifespan"
    },
    "WERKCODES": {
      "AANTAL": "Number",
      "ALLE_WERKCODES": {
        "TITEL": "All work codes"
      },
      "PRODUCTGROEPEN": {
        "TITEL": "Work codes based on product groups"
      },
      "TITEL": "WORK CODE TRENDS",
      "TOP10_OBJECTEN": {
        "TITEL": "Top 10 Objects with the Most Work Codes"
      },
      "TOP10_WERKCODES": {
        "TITEL": "Top 10 Most Common Work Codes"
      }
    }
  },
  "WACHTWOORD_INSTELLEN": {
    "BUTTON_INSTELLEN": "Reset password",
    "EMAILADRES": "Email address",
    "FOUTMELDING": "Error",
    "GEBRUIKERSNAAM": "Username",
    "HERHAAL_NIEUW_WACHTWOORD": "Repeat new password",
    "HINT_TEKST": "Enter your username, email address and new password",
    "MELDING": {
      "EMAILADRES_VERPLICHT": "Email address is required",
      "HERHAAL_WACHTWOORD_VERPLICHT": "New password is required",
      "WACHTWOORD_VERPLICHT": "New password is required"
    },
    "MELDING_WACHTWOORDEN_KOMEN_NIET_OVEREEN": "The new passwords do not match",
    "MELDING_WACHTWOORD_AANGEPAST": "The password has been changed successfully",
    "NIEUW_WACHTWOORD": "New password",
    "TECHNISCH_PROBLEEM": "A technical problem has occurred, please try again or contact the administrator",
    "TITEL": "TotalCare portal - reset password"
  },
  "WACHTWOORD_VERGETEN": {
    "BUTTON": {
      "CODE_AANVRAGEN": "Request code"
    },
    "EMAILADRES": "Email address",
    "GEBRUIKERSNAAM": "Username",
    "MELDING": {
      "EMAILADRES_VERPLICHT": "Email address is required",
      "GEBRUIKERSNAAM_VERPLICHT": "Username is required",
      "OPNIEUW_INGESTELD": "An email has been sent to the email address provided, please follow the instructions in this email to reset your password.",
      "TECHNISCHE_FOUT": "A technical problem has occurred, please try again or contact the administrator",
      "TITEL_OPNIEUW_INGESTELD": "Reset Password"
    },
    "TEKST_HINT": "Enter your username and email address to reset your password",
    "TERUG": "Back to login?",
    "TITEL": "TotalCare portal - forgot your password?"
  },
  "WACHTWOORD_WIJZIGEN": {
    "ANNULEREN": "Cancel",
    "HERHAAL_NIEUW_WACHTWOORD": "Repeat new password",
    "HERHAAL_NIEUW_WACHTWOORD_VERPLICHT": "The repeat password is required",
    "HUIDIG_WACHTWOORD": "Current password",
    "HUIDIG_WACHTWOORD_VERPLICHT": "The current password is required",
    "NIEUW_WACHTWOORD": "New password",
    "NIEUW_WACHTWOORD_KOMTNIETOVEREEN": "The new passwords doesn't match",
    "NIEUW_WACHTWOORD_VERPLICHT": "The new password is required",
    "SUCCESVOL_TEKST": "The password has been changed successfully",
    "SUCCESVOL_TITEL": "Password changed",
    "TITEL": "Change password"
  },
  "WERKCODES": {
    "TRENDS": {
      "ACTUELE_ORDERS": "current orders",
      "ALLES_WEERGEVEN": "show all",
      "ALLE_JAREN": "All years",
      "CIRKELDIAGRAM": "Pie chart",
      "GEGEVENS_TONEN_VOOR": "Show data for",
      "GRID": {
        "AANTAL": "Amount",
        "OBJECT": "Object",
        "WERKCODE": "Work code"
      },
      "OVERVIEW": {
        "GRID": {
          "EXPORT": {
            "BESTANDSNAAM": "Work codes"
          },
          "FILTER_WISSEN": "Show all / clear filters",
          "JAAR": "Year",
          "OBJECT": "Object",
          "OMSCHRIJVING": "Description",
          "OPMERKING_KLANT": "Customer comments",
          "ORDERNUMMER": "Order number",
          "PRODUCTGROEP": "Product group",
          "TYPE": "Type",
          "WERKCODE": "Work code"
        }
      },
      "TABEL": "Table",
      "TITEL": "Work code trends",
      "TOON_ALS": "Show trend as",
      "TOP_MEEST_VOORKOMENDE_OBJECTEN": "Top 10 Objects with the Most Work Codes",
      "TOP_MEEST_VOORKOMENDE_WERKCODES": "Top 10 Most Common Work Codes",
      "VERBERGEN": "Hide",
      "WERKCODE_OVERZICHT": "WORK CODE OVERVIEW"
    }
  }
}